import React, { useCallback, useState } from "react";
import { CreateComponentProps } from "./CreateDashboardComponentTab";
import { Button, Input, Select, SelectOptionType, TextArea } from "@aidkitorg/component-library";
import { Map, MapDataSource } from "@aidkitorg/types/lib/survey";
import { useDashboards } from "../../../Contexts/DashboardsContext";

const MAP_GEOGRAPHIC_DATA_OPTIONS: Array<SelectOptionType> = [
  {value: 'point', label: "Points (Addresses)"},
  {value: 'polygons', label: "Polygons (GeoJSON)"}
]
const getMapGeographicDataOption = (value: string) => {
  return MAP_GEOGRAPHIC_DATA_OPTIONS.find((v) => v.value === value)
}

export const MapComponentConfig: React.FC<CreateComponentProps> = ({ setDisplayMode }) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')

  const [geographicDataOption, setGeographicDataOption] = useState('point')

  const [addressField, setAddressField] = useState('')
  const [geoJsonUrl, setGeoJSONUrl] = useState('')

  const { 
    setStagedComponents, 
  } = useDashboards()

  const saveMapComponent = async () => {
    const source = () => {switch(geographicDataOption) {
      case 'point': 
        return {
          layerName: 'Address',
          kind: 'Applicant Data Source',
          filter: {
            kind: 'Not',
            clause: {
              kind: 'Never'
            }
          },
          columns: [],
          addressField: addressField
        } as MapDataSource
      case 'polygons':
        return {
          layerName: 'GeoJSON',
          kind: 'URL GeoJSON Source',
          url: geoJsonUrl
        } as MapDataSource
      default: 
        return {
          layerName: 'Address',
          kind: 'Applicant Data Source',
          filter: {
            kind: 'Not',
            clause: {
              kind: 'Never'
            }
          },
          columns: [],
          addressField: addressField
        } as MapDataSource 
    }}
    
    
    const mapToStage: Map = {
      kind: 'Map',
      sources: [source()],
      title: title,
      description: description,
    }

    setStagedComponents((prevState) => ([...prevState, mapToStage]))
  }

  const isSaveDisabled = title === '' || 
    (geographicDataOption === 'point' && addressField === '') ||
    (geographicDataOption === 'polygons' && (geoJsonUrl === ''))
    
  return (
    <div className="flex flex-col gap-y-2">
      <div className="font-medium text-lg">
        Add Map
      </div>

      <Input 
        required
        label="Map Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <Select 
        options={MAP_GEOGRAPHIC_DATA_OPTIONS}
        label="Geographic Data Type"
        description="Geographic data type for this map"
        labelLocation="above"
        value={getMapGeographicDataOption(geographicDataOption)}
        onChange={(value) => { 
          console.log('rerender')
          setGeographicDataOption(value.value)}}
      />

      {/* TODO: update these to be dropdowns */}
      {geographicDataOption === 'point' && (
        <Input 
          required
          label="Address Field"
          value={addressField}
          onChange={(e) => setAddressField(e.target.value)}
        />
      )}
      {geographicDataOption === 'polygons' && (
        <Input 
          required
          label="GeoJSON Import"
          value={geoJsonUrl}
          onChange={(e) => setGeoJSONUrl(e.target.value)}
        />
      )}

      <TextArea
        label="Description"
        showLabel
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
      <div className="flex justify-between gap-x-2 pt-2">
        <Button onClick={() => setDisplayMode('create')} className="!w-1/2" variant="secondary">Cancel</Button>
        <Button isDisabled={isSaveDisabled} onClick={saveMapComponent} className="!w-1/2">Save</Button>
      </div>
    </div>
  )
}